export default "__VITE_ASSET__FUQ7wtlD__"